import React from "react";
import styled from "styled-components";
import { CompanyBranch } from "../../../types/branch";
import { colors } from "../../../styles/theme";

interface BranchAvatarProps {
  branch: CompanyBranch;
  size?: number;
  onClick?: () => void;
}

const AvatarContainer = styled.div<{ size: number; clickable: boolean }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.primary};
  color: ${colors.white};
  font-weight: 600;
  font-size: ${props => props.size * 0.4}px;
  overflow: hidden;
  flex-shrink: 0;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  transition: all 0.2s ease;

  &:hover {
    transform: ${props => props.clickable ? 'scale(1.05)' : 'none'};
    box-shadow: ${props => props.clickable ? '0 4px 12px rgba(79, 70, 229, 0.3)' : 'none'};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

/**
 * Generuje inicjały z nazwy brancha:
 * - Jednoczłonowa: pierwsza litera (np. "Restauracja" → "R")
 * - Dwuczłonowa: pierwsze litery obu słów (np. "Złota Rybka" → "ZR")
 * - Wieloczłonowa (3+): pierwsze litery DWÓCH pierwszych słów (np. "Bar Pod Lipami" → "BP")
 */
const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);

  if (words.length === 0) return "?";
  if (words.length === 1) return words[0][0].toUpperCase();

  // Zawsze bierzemy tylko 2 pierwsze słowa
  return (words[0][0] + words[1][0]).toUpperCase();
};

export const BranchAvatar: React.FC<BranchAvatarProps> = ({
  branch,
  size = 40,
  onClick
}) => {
  return (
    <AvatarContainer size={size} clickable={!!onClick} onClick={onClick}>
      {branch.logoUrl ? (
        <img src={branch.logoUrl} alt={branch.name} />
      ) : (
        getInitials(branch.name)
      )}
    </AvatarContainer>
  );
};
